const astroDice = {
  pageTitle: '占星骰子',
  bannerTitle: '占星骰子',
  bannerDesc: '三顆骰子 · 星體 · 星座 · 宮位 · 揭示當下宇宙訊息',
  intro: {
    title: '何為占星骰子',
    badge: '新手必讀',
    desc: '占星骰子是現代占星學衍生的一種直覺占卜工具，將行星、星座、宮位三大占星要素化為三顆骰子。擲出後得到一個獨特的星象組合，為當下問題提供多維度的思考切入點，而非命運的判決。',
    step0: '靜心默想，在心中聚焦你所問之事',
    step1: '投擲三顆骰子，分別對應星體、星座、宮位',
    step2: '結合三骰組合與問題方向，獲得專屬的當下指引',
  },
  historyTitle: '歷史記錄',
  diceLabel_planet: '星體',
  diceLabel_sign: '星座',
  diceLabel_house: '宮位',
  rollBtn: '投擲骰子',
  rerollBtn: '再次投擲',
  rolling: '骰子飛旋中···',
  placeholder: '···',
  // 問題驅動層
  questionSectionTitle: '你想問什麼？',
  questionRequiredHint: '請先選擇問題方向',
  questionReady: '問題已就緒',
  selectQuestionType: '選擇問題類型',
  presetQuestionHint: '常見問題（點擊快速填入）',
  typeYourQuestion: '或自己輸入問題',
  questionPlaceholder: '心中想好的問題……',
  clarityLabel: '清晰度',
  rollBtnNoQuestion: '投擲骰子（未選問題）',
  rollHintNoQuestion: '建議先選擇問題類型，讓骰子判讀更有针對性',
  qTypeLove: '感情',
  qTypeCareer: '事業',
  qTypeTiming: '時機',
  qTypeDecision: '決策',
  qTypeAction: '行動',
  qTypeRisk: '風險',
  qTypeRelation: '人際',
  qTypeSelf: '自我',
  qTypeGeneral: '綜合',
  presetQuestions: {
    love: ['TA對我是真心的嗎？', '這段感情尚值得繼續嗎？', '現在表白合適嗎？', '分開後是否有復合可能？', '今年的感情運如何？'],
    career: ['這份工作機會尚值得把握嗎？', '現在足槽時機對嗎？', '創業方向是否可行？', '升職的可能性有多大？', '如何提升職場競爭力？'],
    timing: ['現在開始這件事合適嗎？', '什麼時候是最好的時機？', '還需要等多久？', '這件事近期會有進展嗎？'],
    decision: ['要不要接受這個邀請？', '應該離開還是堅持？', '這個決定方向對嗎？', '尚不尚得投入精力？'],
    action: ['怎麼推進這件事？', '下一步該如何行動？', '有什麼需要馬上做的？', '如何克服當下的障礙？'],
    risk: ['這件事有什麼風險？', '我擔心的會不會成真？', '繼續下去安全嗎？', '有哪些隱患需要注意？'],
    relation: ['這段關係尚值得深交嗎？', '如何改善與對方的關係？', '對方是否尚值得信任？', '如何處理當下的人際矛盾？'],
    self: ['我現在最需要關注什麼？', '我的哪個特質在阻礙我？', '此刻內心真正想要什麼？', '我現在的狀態適合行動嗎？'],
    general: ['宇宙現在給我什麼訊號？', '當下最尚值得關注的方向是？', '我現在的能量場如何？'],
  },
  howToTitle: '如何使用占星骰子？',
  howToSteps: [
    '選擇你的問題類型（感情/事業/風險……）',
    '輸入或選擇你的具體問題',
    '點擊「投擲骰子」讓宇宙給出三骰組合',
    '三骰分別代表：星體能量 · 星座風格 · 宮位領域',
    '問題類型×骰子組合，獲得專屬判讀',
  ],
  disclaimer: '占星骰子為占星學中的娛樂工具，當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
  refTitle: '占星參考',
  tabPlanets: '十大星體',
  tabSigns: '十二星座',
  tabHouses: '十二宮位',
  sectionBody: '關聯身體',
  sectionRuling: '主管星座',
  sectionAreas: '主要影響領域',
  sectionKeywords: '核心關鍵詞',
  sectionGuidance: '宇宙指引',
  sectionDetail: '星體解讀',
  highlightTitle: '宇宙核心訊息',
  labelPlanetEnergy: '星體能量',
  labelSignStyle: '星座風格',
  labelHouseDomain: '宮位領域',
  labelReading: '解讀正文',
  labelPlanetGuidance: '星體指引',
  shadowPrefix: '座陰影面：',
  shareTitle: '分享骰子結果',
  shareHint: '長按圖片即可儲存到相簿',
  saveBtn: '儲存圖片',
  closeBtn: '關閉',
  generating: '生成卡片中…',
  genFailed: '生成失敗',
  regenerate: '重新生成',
  cardBrand: '占星骰子',
  cardSlogan: '── 宇宙的訊息 ──',
  cardReadingTitle: '宇宙解讀',
  cardGuidanceTitle: '當下指引',
  cardDisclaimer: '本結果僅供娛樂參考，不代表任何現實指導意義',
  signSuffix: '座',
  elementDot: '·',

  planets: [
    {
      name: '太陽', meaning: '自我意識·生命力·創造力',
      keywords: ['自我', '權威', '活力', '榮耀'],
      verb: '照亮',
      advices: [
        '順應內心真實渴望，勇於表達自我，不依賴外界認可',
        '在此領域成為領導者，綻放你獨特的光芒',
        '保持創造力，你的意志就是前進的燃料',
      ],
      detail: '太陽是占星中最核心的天體，代表你的「本質自我」——你天生攜帶的使命感、活力與創造力。它決定了你渴望被人看見的方式，以及你如何追求自我實現。太陽落在某個位置，就像聚光燈打在那個區域，指向你此生需要發光的舞台。',
      rulingSign: '獅子座',
      bodyPart: '心臟、脊椎、眼睛',
      lifeAreas: ['自我認同', '事業方向', '父親/權威關係', '創造力表達'],
      beginnerTip: '太陽 = 你的靈魂身份證，你最想被記住的樣子',
    },
    {
      name: '月亮', meaning: '情感·本能·潛意識',
      keywords: ['情感', '母性', '直覺', '內心'],
      verb: '感知',
      advices: [
        '傾聽內心深處的直覺，它比任何邏輯都更貼近真相',
        '給自己情感上的空間，允許感受自然流動',
        '照顧好內在的安全感，從而向外散發溫柔力量',
      ],
      detail: '月亮代表你的情緒世界與潛意識反應——那些不經思考就自然冒出的感受、習慣和防禦機制。它關聯你與母親/養育者的早期關係，以及你內心深處對「安全感」的定義。當你感到不安時，月亮能量就在被激活；當你感到被滋養時，也是它在發揮作用。',
      rulingSign: '巨蟹座',
      bodyPart: '胃部、乳房、體液循環',
      lifeAreas: ['情緒反應', '家庭關係', '安全感來源', '童年模式'],
      beginnerTip: '月亮 = 你的內心小孩，什麼讓你有家的感覺',
    },
    {
      name: '水星', meaning: '思維·溝通·學習',
      keywords: ['溝通', '思維', '學習', '邏輯'],
      verb: '傳達',
      advices: [
        '清晰表達想法，準確的溝通能打開意想不到的大門',
        '保持好奇心，持續學習將是此刻最有效的投資',
        '審視自己的思維模式，調整語言與溝通方式',
      ],
      detail: '水星主管你的思維方式、語言表達和資訊處理能力。它決定了你如何學習新知識、如何與他人溝通，以及你的邏輯結構是偏感性還是理性。水星還與短途出行、日常事務和兄弟姐妹關係有關。水逆時期，水星能量受阻，溝通與計劃容易出現偏差。',
      rulingSign: '雙子座、處女座',
      bodyPart: '神經系統、手、肺、喉嚨',
      lifeAreas: ['思維方式', '溝通表達', '學習能力', '合同與協議'],
      beginnerTip: '水星 = 你的大腦作業系統，決定你怎麼想、怎麼說',
    },
    {
      name: '金星', meaning: '愛情·美感·價值觀',
      keywords: ['愛情', '美麗', '享受', '和諧'],
      verb: '吸引',
      advices: [
        '創造美好體驗，允許愛與豐盛自然流入你的生命',
        '檢視自己的價值觀，確保你追求的是真正值得的事',
        '開放心扉，和諧關係從接納自己的美開始',
      ],
      detail: '金星代表你對美、愛與享受的感知方式，以及你認為什麼是「有價值」的事物。它不只關乎浪漫愛情，更影響你的審美品味、消費習慣，以及在關係中給予和接受愛的方式。金星所在的位置顯示你在哪裡最能感受到吸引力與愉悅感。',
      rulingSign: '金牛座、天秤座',
      bodyPart: '喉嚨、腎臟、皮膚、腰部',
      lifeAreas: ['愛情關係', '審美品味', '金錢態度', '社交魅力'],
      beginnerTip: '金星 = 你的愛情天線，你被什麼吸引、又如何吸引別人',
    },
    {
      name: '火星', meaning: '行動力·欲望·競爭',
      keywords: ['行動', '熱情', '競爭', '勇氣'],
      verb: '激發',
      advices: [
        '勇敢採取行動，此刻的行動力將決定結果',
        '將內在的熱情定向，專注於最核心的目標',
        '面對挑戰不退縮，你的勇氣就是最強的資本',
      ],
      detail: '火星是行動與欲望之星，代表你追求目標的方式、性欲能量、以及面對衝突時的反應模式。它告訴你什麼能點燃你的熱情，你如何戰鬥，如何保護自己。健康的火星能量帶來勇氣與執行力；過度激活則可能變成衝動與攻擊性。',
      rulingSign: '白羊座（傳統也主管天蠍座）',
      bodyPart: '腎上腺、肌肉、頭部、血液',
      lifeAreas: ['行動力與執行', '競爭與衝突', '性能量', '勇氣與冒險'],
      beginnerTip: '火星 = 你的行動引擎，什麼讓你願意為它而戰',
    },
    {
      name: '木星', meaning: '擴張·幸運·哲學',
      keywords: ['幸運', '擴張', '智慧', '繁榮'],
      verb: '擴展',
      advices: [
        '保持開放與樂觀，此刻幸運之門正向你敞開',
        '放眼更廣闊的格局，限制來自於你自設的邊界',
        '信任宇宙的豐盛，慷慨付出也將帶來更大回流',
      ],
      detail: '木星是占星中的「幸運星」，代表擴張、豐盛與機遇。它所在的位置往往是你人生中相對順遂、容易獲得祝福的領域。木星也主管哲學、信仰、高等教育與遠途旅行，象徵你對更宏觀意義的追尋。它的另一面是過度擴張——凡事過猶不及。',
      rulingSign: '射手座（傳統也主管雙魚座）',
      bodyPart: '肝臟、臀部、大腿',
      lifeAreas: ['幸運與機遇', '信仰與哲學', '高等教育', '海外與擴展'],
      beginnerTip: '木星 = 你的幸運放大器，它在哪你就容易在哪收穫好運',
    },
    {
      name: '土星', meaning: '責任·限制·紀律',
      keywords: ['責任', '紀律', '考驗', '結構'],
      verb: '考驗',
      advices: [
        '踏實建構，用耐心和堅持將結果雕刻成形',
        '正視挑戰，此刻的限制恰恰是成長的入口',
        '承擔起屬於你的責任，穩固的基礎終將支撐高峰',
      ],
      detail: '土星是「嚴師」，代表規則、邊界、責任與長期成就。它所在的位置往往是你感到壓力、需要付出更多努力的領域——但正是在這裡，你能建立最持久的成就。土星考驗你是否有足夠的耐心與毅力。約29年一個土星回歸，是人生重大蛻變的時刻。',
      rulingSign: '摩羯座（傳統也主管水瓶座）',
      bodyPart: '骨骼、牙齒、皮膚、膝蓋',
      lifeAreas: ['紀律與自律', '長期目標', '職業成就', '父親/權威關係'],
      beginnerTip: '土星 = 你的人生導師，它考驗你的地方也是你最終發光的地方',
    },
    {
      name: '天王星', meaning: '變革·創新·突破',
      keywords: ['變革', '創新', '自由', '獨特'],
      verb: '顛覆',
      advices: [
        '擁抱意外的變化，它攜帶著顛覆性的智慧',
        '突破舊有框架，創新的勇氣將帶來真正的自由',
        '允許生命走向一條不曾預料的路，可能正是捷徑',
      ],
      detail: '天王星是外行星，象徵突變、革命與打破常規。它的能量來得突然，往往以意想不到的方式顛覆既有秩序。天王星在個人星盤中運行緩慢（84年一圈），它所經過的宮位往往經歷劇烈變化與解放。它代表你渴望自由、與眾不同的那一面。',
      rulingSign: '水瓶座',
      bodyPart: '神經系統、踝關節、循環系統',
      lifeAreas: ['突破與變革', '科技與創新', '獨立自由', '人道主義'],
      beginnerTip: '天王星 = 你生命中的「意外驚喜」，它叫你打破框架',
    },
    {
      name: '海王星', meaning: '靈感·幻象·神秘',
      keywords: ['靈感', '夢想', '神秘', '直覺'],
      verb: '溶解',
      advices: [
        '相信內在的靈感，它來自更高維度的指引',
        '跟隨心靈的感召，此刻的直覺比分析更可靠',
        '保持清醒的同時放開想象，夢想是行動的藍圖',
      ],
      detail: '海王星是靈性與幻象之星，代表夢想、直覺、靈感和神秘體驗。它會「溶解」邊界——讓你感受到萬物相連，也可能模糊現實與幻想的界限。海王星所在的位置容易產生理想化、幻覺或欺騙，但也是藝術靈感、靈性修行最深厚的土壤。',
      rulingSign: '雙魚座',
      bodyPart: '腳部、免疫系統、松果體',
      lifeAreas: ['靈性與直覺', '藝術創作', '幻象與理想', '無私奉獻'],
      beginnerTip: '海王星 = 你的夢境頻道，既是靈感來源，也要防止迷失',
    },
    {
      name: '冥王星', meaning: '轉化·重生·深層力量',
      keywords: ['轉化', '權力', '重生', '深層'],
      verb: '轉化',
      advices: [
        '放下過時的舊模式，徹底的蛻變正在等待你',
        '深入內在尋找真正的力量，權威來自於內部',
        '接受這段結束，它正在為更深刻的重生騰出空間',
      ],
      detail: '冥王星是最遙遠的外行星，代表死亡與重生、深層權力與徹底轉化。它所到之處，舊有的結構會被摧毀，為新生騰出空間。這個過程往往伴隨著痛苦，但最終帶來真正的蛻變。冥王星揭示你最深層的恐懼、欲望，以及你渴望掌控的事物。',
      rulingSign: '天蠍座',
      bodyPart: '生殖系統、排泄系統、再生細胞',
      lifeAreas: ['深層轉化', '權力與控制', '心理療癒', '生死與遺產'],
      beginnerTip: '冥王星 = 你生命的鳳凰時刻，破而後立，涅槃重生',
    },
  ],

  signs: [
    { name: '白羊', element: '火', modality: '基本', meaning: '開創·衝勁', keywords: ['主動', '勇敢', '衝動', '熱情'], style: '以勇敢直接的方式大步向前', styleShort: '勇敢直接', shadow: '注意衝動行事，避免急於求成' },
    { name: '金牛', element: '土', modality: '固定', meaning: '穩固·感官', keywords: ['穩定', '務實', '執著', '享受'], style: '以踏實穩健的步伐一步一步積累', styleShort: '踏實穩健', shadow: '避免過於固執，適時接受變化' },
    { name: '雙子', element: '風', modality: '變動', meaning: '溝通·變化', keywords: ['靈活', '好奇', '多變', '機智'], style: '以靈活多變且充滿好奇的方式探索', styleShort: '靈活多變', shadow: '避免思緒發散，需要專注落實' },
    { name: '巨蟹', element: '水', modality: '基本', meaning: '保護·情感', keywords: ['敏感', '母性', '保護', '直覺'], style: '以溫柔細膩且充滿情感的方式滋養', styleShort: '溫柔細膩', shadow: '注意情緒邊界，避免過度依賴' },
    { name: '獅子', element: '火', modality: '固定', meaning: '光芒·創造', keywords: ['自信', '創意', '領袖', '熱情'], style: '以自信耀眼且充滿創意的方式發光', styleShort: '自信耀眼', shadow: '保持謙遜，避免自我中心' },
    { name: '處女', element: '土', modality: '變動', meaning: '分析·服務', keywords: ['細緻', '分析', '服務', '完美'], style: '以細緻入微且追求精準的方式打磨', styleShort: '細緻入微', shadow: '放下過度挑剔，允許事情足夠好' },
    { name: '天秤', element: '風', modality: '基本', meaning: '平衡·和諧', keywords: ['公正', '優雅', '合作', '平衡'], style: '以優雅平衡且注重和諧的方式協調', styleShort: '優雅平衡', shadow: '避免優柔寡斷，學會做出決定' },
    { name: '天蠍', element: '水', modality: '固定', meaning: '深邃·轉化', keywords: ['洞察', '神秘', '執著', '轉化'], style: '以深刻洞察且不畏黑暗的方式穿透', styleShort: '深刻洞察', shadow: '釋放控制慾，允許過去自然消逝' },
    { name: '射手', element: '火', modality: '變動', meaning: '探索·自由', keywords: ['自由', '哲學', '樂觀', '探索'], style: '以樂觀開闊且追求真理的方式飛翔', styleShort: '樂觀開闊', shadow: '培養專注與落實，理想需要根基' },
    { name: '摩羯', element: '土', modality: '基本', meaning: '目標·權威', keywords: ['雄心', '紀律', '責任', '實際'], style: '以堅定自律且著眼長遠的方式攀登', styleShort: '堅定自律', shadow: '放下過度控制，允許生命有柔軟時刻' },
    { name: '水瓶', element: '風', modality: '固定', meaning: '創新·人道', keywords: ['創新', '獨立', '博愛', '改革'], style: '以獨特前衛且充滿人道關懷的方式革新', styleShort: '獨特前衛', shadow: '保持情感連接，避免過於疏離' },
    { name: '雙魚', element: '水', modality: '變動', meaning: '感悟·靈性', keywords: ['同情', '靈性', '直覺', '夢幻'], style: '以慈悲包容且富有靈性感知的方式融合', styleShort: '慈悲包容', shadow: '保持清醒現實感，避免逃避責任' },
  ],

  houses: [
    { name: '第一宮', meaning: '自我、外在形象、身體', keywords: ['個性', '外貌', '開始'], domain: '你的自我形象與對外展現', question: '你如何向世界展示真實的自己？' },
    { name: '第二宮', meaning: '財富、價值觀、物質', keywords: ['金錢', '資源', '價值'], domain: '你的物質資源與內在價值體系', question: '你真正珍視的是什麼？' },
    { name: '第三宮', meaning: '溝通、學習、短途旅行', keywords: ['思維', '兄弟', '學習'], domain: '你的日常溝通與學習模式', question: '你如何傳遞與接收訊息？' },
    { name: '第四宮', meaning: '家庭、根基、內心世界', keywords: ['家庭', '母親', '根基'], domain: '你的家庭情感與內心根基', question: '什麼讓你感到真正的歸屬與安全？' },
    { name: '第五宮', meaning: '創造、愛情、娛樂', keywords: ['創意', '戀愛', '孩子'], domain: '你的創造力與浪漫體驗', question: '什麼事情讓你全情投入、忘卻時間？' },
    { name: '第六宮', meaning: '工作、健康、日常', keywords: ['服務', '健康', '例行'], domain: '你的日常工作與身體健康', question: '你的日常習慣是在滋養還是消耗你？' },
    { name: '第七宮', meaning: '伴侶、合作、公開關係', keywords: ['婚姻', '合夥', '關係'], domain: '你的親密關係與合作模式', question: '你在關係中尋求什麼，又給予什麼？' },
    { name: '第八宮', meaning: '轉化、深層資源、秘密', keywords: ['轉化', '秘密', '遺產'], domain: '你的深層轉化與心理資源', question: '你準備好放下哪些東西來完成蛻變？' },
    { name: '第九宮', meaning: '哲學、信念、遠方', keywords: ['信念', '旅行', '智慧'], domain: '你的人生信念與精神探索', question: '什麼樣的真理在引導你前進的方向？' },
    { name: '第十宮', meaning: '事業、聲譽、社會地位', keywords: ['事業', '成就', '權威'], domain: '你的社會角色與職業成就', question: '你想在這個世界上留下什麼樣的印記？' },
    { name: '第十一宮', meaning: '友誼、願景、社群', keywords: ['友情', '社群', '目標'], domain: '你的人際網絡與未來願景', question: '與誰同行，你才能抵達真正想去的地方？' },
    { name: '第十二宮', meaning: '潛意識、靈性、隱藏課題', keywords: ['隱藏', '犧牲', '靈性'], domain: '你的潛意識模式與靈性成長', question: '有什麼被遺忘的部分，正在尋找被看見？' },
  ],

  interp: {
    openings: [
      '{{planetName}}正以{{signName}}座的方式運作——{{signStyle}}，{{planetVerb}}著你內在{{planetKeyword0}}的力量。',
      '{{element}}象的{{signName}}座賦予了{{planetName}}{{signStyleShort}}的色彩，這股能量正在湧動。',
      '宇宙將{{planetName}}（{{planetMeaning}}）置於{{signName}}座——{{signModality}}品質的{{element}}象星座，意味著{{planetKeyword2}}將以{{signKeyword3}}的形態顯現。',
    ],
    middles: [
      '這一能量落入{{houseName}}——{{houseDomain}}——提示你：{{houseQuestion}}',
      '焦點集中在{{houseName}}的領域：{{houseMeaning}}。{{planetName}}在此{{planetVerb}}，可能正在重塑你對{{houseKeyword4}}的理解。',
      '{{houseName}}是此刻的舞台，{{planetName}}攜帶{{element}}象{{signName}}的能量在此運行，你的{{houseKeyword0}}與{{houseKeyword1}}正經歷轉變。',
    ],
    closings: [
      '{{shadow}}，但此刻最重要的是：{{advice}}',
      '{{advice}}',
    ],
    highlights: [
      '{{planetName}} × {{signName}}座 × {{houseName}} — 核心議題：{{planetKeyword8}}與{{houseKeyword0}}',
      '當下宇宙密碼：{{signModality}}{{element}}象的{{planetVerb}}力，作用於{{houseDomainShort}}',
      '{{signName}}座{{planetName}}落{{houseName}}：{{signKeyword9}}遇見{{houseKeyword10}}',
    ],
  },
};

export default astroDice;
